import type { Theme } from './plugins/types';

const THEME_KEY = 'hawk_plugins_theme';
const ATTR = 'data-theme';

export function currentTheme(): Theme {
  return document.documentElement.getAttribute(ATTR) === 'dark'
    ? 'dark'
    : 'light';
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute(ATTR, theme);
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    /* ignore */
  }
}

export function initTheme(): void {
  let stored: string | null = null;
  try {
    stored = localStorage.getItem(THEME_KEY);
  } catch {
    /* ignore */
  }
  const theme: Theme =
    stored === 'dark' || stored === 'light'
      ? stored
      : window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
  document.documentElement.setAttribute(ATTR, theme);
}

/**
 * Observe theme flips on <html>. Used by the plugin host to implement
 * `ctx.subscribeTheme`, and by the layout to re-render its toggle.
 */
export function observeTheme(listener: (theme: Theme) => void): () => void {
  let last = currentTheme();
  const observer = new MutationObserver(() => {
    const next = currentTheme();
    if (next === last) return;
    last = next;
    listener(next);
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: [ATTR],
  });
  return () => observer.disconnect();
}
